import { useEffect } from "react";
import { api } from "../lib/api";

// Lighten a hex color by mixing with white
function lighten(hex, amt = 0.15) {
  try {
    const c = hex.replace("#", "");
    const num = parseInt(c.length === 3 ? c.split("").map(x=>x+x).join("") : c, 16);
    const r = Math.min(255, Math.round(((num >> 16) & 255) + 255 * amt));
    const g = Math.min(255, Math.round(((num >> 8) & 255) + 255 * amt));
    const b = Math.min(255, Math.round((num & 255) + 255 * amt));
    return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, "0")}`;
  } catch { return hex; }
}

function apply(site) {
  const root = document.documentElement;
  if (site.color_primary) {
    root.style.setProperty("--deep-blue", site.color_primary);
    root.style.setProperty("--deep-blue-light", lighten(site.color_primary, 0.15));
  }
  if (site.color_accent) {
    root.style.setProperty("--gold", site.color_accent);
    root.style.setProperty("--gold-soft", lighten(site.color_accent, 0.15));
  }
  // Favicon
  if (site.favicon_url) {
    let link = document.querySelector("link[rel='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = site.favicon_url;
  }
  // Document title / meta
  if (site.logo_text) document.title = `${site.logo_text} | Agir pour l'avenir des enfants`;
}

export default function ThemeApplier() {
  useEffect(() => {
    const load = () => api.get("/settings").then(r => apply(r.data?.site || {})).catch(() => {});
    load();
    window.addEventListener("lel-settings-updated", load);
    return () => window.removeEventListener("lel-settings-updated", load);
  }, []);
  return null;
}
